<template>
  <div :class="$attrs.class" class="flex flex-col space-x-8 mb-2">
    <div class="flex flex-row space-x-2 items-center">
      <input v-if="type === 'radio'" :id="id" v-model="innerValue" :disabled="disabled" :type="type" :value="data">
      <label v-else-if="type === 'checkbox'" class="custom-checkbox">
        <input
            :id="id"
            :value="data"
            :checked="isChecked"
            :disabled="disabled"
            type="checkbox"
            @change="toggleValue"
        />
        <span class="checkmark" :class="checkMarkClass"></span>
      </label>
      <label :class="labelClass" :for="id" class="block text-base font-light">{{ label }}</label>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {randomStr} from "@/helpers/helpers";

export default {
  name: "CheckBox",
  props: {
    data: {
      type: [String, Number, Boolean],
      require: true,
    },
    value: {
      type: [String, Number, Boolean, Array, null],
      require: true,
    },
    label: String,
    labelClass: [String, Array],
    type: {
      type: String,
      default: "checkbox"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkMarkClass: {
      type: String,
      default: "top-0"
    }
  },
  computed: {
    id() {
      return randomStr();
    },
    innerValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
        this.$emit("change", newValue);
      }
    },
    // Kiểm tra checkbox có đang được chọn không
    isChecked() {
      if (Array.isArray(this.value)) {
        return this.value.includes(this.data);
      }
      if (typeof this.value === "boolean") {
        return this.value;
      }
      return this.value === this.data;
    },
  },
  methods: {
    // cast data vào cùng kiểu với phần tử hiện có trong mảng (nếu có)
    castToArrayType(val, arr) {
      if (!Array.isArray(arr) || arr.length === 0) return val;
      const t = typeof arr[0];
      if (t === "number") {
        const n = Number(val);
        return isNaN(n) ? val : n;
      }
      if (t === "boolean") {
        return val === true || val === "true";
      }
      return String(val);
    },

    toggleValue(e) {
      const checked = e.target.checked;

      if (Array.isArray(this.value)) {
        const updated = [...this.value];
        const idx = updated.findIndex(v => String(v) === String(this.data));

        if (checked && idx === -1) {
          // push với kiểu giống phần tử hiện có trong mảng
          updated.push(this.castToArrayType(this.data, this.value));
        } else if (!checked && idx > -1) {
          updated.splice(idx, 1);
        }

        this.$emit("input", updated);
        this.$emit("change", updated);
        return;
      }

      if (typeof this.value === "boolean") {
        this.$emit("input", checked);
        this.$emit("change", checked);
        return;
      }

      this.$emit("input", checked ? this.data : null);
      this.$emit("change", checked ? this.data : null);
    }
  }
}
</script>